import Offcanvas from 'react-bootstrap/Offcanvas';

const OffCanvas = (props: any) => {
  return (
    <Offcanvas
      show={props.offCanvasShow}
      onHide={() => props.setOffCanvasShow(false)}
      backdrop={props.backdrop ?? true}
      trapFocus={true}
      placement={props.placement ? props.placement : 'end'}
      className={props.className ? props.className : ''} // Add custom class
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          <div>
            <div className='d-flex align-items-center gap-2'>
              <strong className='fs-20 fw-semibold'>{props.title}</strong>
              {props.titleAction}
            </div>
            {props.subTitle && <div className='fs-11 text-truncate fw-normal text-light'>{props.subTitle}</div>}
          </div>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className='pb-0'>
        {
          props.children
        }
      </Offcanvas.Body>
    </Offcanvas>
  );
}
export default OffCanvas;
